module.exports = __webpack_public_path__ + "img/delete.a6564182.svg";